import { render, staticRenderFns } from "./teleport.vue?vue&type=template&id=28153b4e&scoped=true&"
import script from "./teleport.vue?vue&type=script&lang=js&"
export * from "./teleport.vue?vue&type=script&lang=js&"
import style0 from "./teleport.vue?vue&type=style&index=0&id=28153b4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28153b4e",
  null
  
)

export default component.exports